/* Step 3 of the feed import flow: success summary.
   Used for both podcast and RSS feed OPML imports. */

import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CheckCircle2, Rss } from "lucide-react";

interface PodcastImportResultsProps {
  imported: number;
  skipped: number;
  importedNames: string[];
  onDone: () => void;
  feedLabel?: string;
}

export function PodcastImportResults({
  imported,
  skipped,
  importedNames,
  onDone,
  feedLabel = "podcast",
}: PodcastImportResultsProps) {
  const plural = imported !== 1 ? "s" : "";

  return (
    <div className="space-y-4 text-center">
      <div className="flex flex-col items-center gap-2">
        <CheckCircle2 className="size-10 text-primary" />
        <h3 className="text-lg font-semibold">
          {imported} {feedLabel}{plural} imported
        </h3>
        {skipped > 0 && (
          <p className="text-sm text-muted-foreground">
            {skipped} already existed and {skipped === 1 ? "was" : "were"} skipped
          </p>
        )}
      </div>

      {importedNames.length > 0 && (
        <ScrollArea className="max-h-48 rounded-md border text-left">
          <div className="p-2 space-y-0.5">
            {importedNames.map((name, i) => (
              <div
                key={i}
                className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm"
              >
                <Rss className="size-3.5 text-muted-foreground shrink-0" />
                <span className="truncate">{name}</span>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}

      <Button onClick={onDone} className="w-full">
        Done
      </Button>
    </div>
  );
}
